import React from "react";
import FirstDocs from "../sections/documentation/FirstDocs";
import TrialDocs from "../sections/documentation/TrialDocs";
import hljs from "highlight.js";

function Docs() {
  return (
    //     {/* <div className="absolute bottom-12 w-full md:w-1/2 z-10">
    //       <hr class="h-px mb-2 md:mb-6 bg-gray-400 border-0 " />
    //       <div>
    //         <div>
    //           <button className="hidden md:inline-flex items-center bg-gray-100 border-0 py-1 px-3 focus:outline-none hover:bg-gray-200 rounded text-base mt-4 md:mt-0 ">
    //             <svg
    //               fill="none"
    //               stroke="currentColor"
    //               strokeLinecap="round"
    //               strokeLinejoin="round"
    //               strokeWidth={2}
    //               className="w-4 h-4 mr-1 rotate-180 "
    //               viewBox="0 0 24 24"
    //             >
    //               <path d="M5 12h14M12 5l7 7-7 7" />
    //             </svg>
    //             Previous Section
    //           </button>
    //           <button className="inline-flex items-center bg-gray-100 border-0 py-1 px-3 focus:outline-none hover:bg-gray-200 rounded text-base mt-4 md:mt-0 absolute right-10">
    //             Next Section
    //             <svg
    //               fill="none"
    //               stroke="currentColor"
    //               strokeLinecap="round"
    //               strokeLinejoin="round"
    //               strokeWidth={2}
    //               className="w-4 h-4 ml-1 "
    //               viewBox="0 0 24 24"
    //             >
    //               <path d="M5 12h14M12 5l7 7-7 7" />
    //             </svg>
    //           </button>
    //         </div>
    //       </div>
    //     </div> */}
    <div className="flex">
      <div className="fixed top-10 right-5 md:right-10 z-20">
        <span class="bg-yellow-100 text-yellow-800 text-sm font-medium mr-2 px-5 py-2.5 rounded">
          alpha
        </span>
      </div>
      <aside className="sticky hidden top-0 h-screen w-18 sm:block sm:w-[21rem] border border-gray-200 p-3 sm:selection:flex flex-col space-y-5">
        <h1 className="my-4 text-center text-yellow-900">Docs Pages</h1>
        <button className="inline-flex items-center border-0 py-1 px-3 focus:outline-none hover:bg-gray-200 rounded text-base mt-2 md:mt-0 p-2">
          Getting Started
        </button>
        {/* <button className="inline-flex items-center border-0 py-1 px-3 focus:outline-none hover:bg-gray-200 rounded text-base mt-2 md:mt-0">
          Create App
        </button>
        <button className="inline-flex items-center border-0 py-1 px-3 focus:outline-none hover:bg-gray-200 rounded text-base mt-2 md:mt-0">
          Stk Intergaration
        </button>
        <button className="inline-flex items-center border-0 py-1 px-3 focus:outline-none hover:bg-gray-200 rounded text-base mt-2 md:mt-0">
          Handle Callback
        </button> */}
      </aside>
      <section className="w-full scrollbar-hide overflow-scroll col-span-5 sm:col-span-4 p-4">
        <h1 className="mb-4 text-yellow-900">GETTING STARTED</h1>
        {/* <FirstDocs /> */}

        <TrialDocs />
      </section>
      <div className="sticky top-0 h-screen hidden lg:w-[600px] lg:block p-2 border border-gray-200 ">
        <h1 className="my-4 text-center text-yellow-900"></h1>
      </div>
    </div>
  );
}

export default Docs;
